// src/hooks/useScrollToItem.js
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

const useScrollToItem = (headerSelector) => {
  const location = useLocation();
  return useCallback(
    (element) => {
      if (!element) return;

      // Find header element
      const header = document.querySelector(headerSelector) 
      const headerHeight = header ? header.offsetHeight : 0;
      // Get clicked item absolute position
      const itemPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: itemPosition - (headerHeight + (location?.pathname == '/' ? 85 : 0)),
        behavior: "smooth",
      });
    },
    [headerSelector]
  );
};

export default useScrollToItem;
